<div class="header">
  <div *ngIf="step === 'comment-step'" class="header__icon">
    <mat-icon (click)="previousStep()">arrow_back</mat-icon>
  </div>
  <div class="header__icon right">
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>
</div>
<div class="content">
  <app-score-step
    *ngIf="step === 'score-step'"
    (nextStepEvent)="nextStep($event)"
    [score]="netPromoterScoreForm.get('score').value"
  ></app-score-step>
  <app-comment-step
    *ngIf="step === 'comment-step'"
    (nextStepEvent)="nextStep($event)"
    [commentForm]="netPromoterScoreForm.get('comment')"
  ></app-comment-step>
  <app-final-step *ngIf="step === 'final-step'" (nextStepEvent)="nextStep($event)"></app-final-step>
</div>
<div class="footer">
  <div class="footer__content">
    <p>{{ 'NET_PROMOTER_SCORE.PROGRESS' | translate: { stepIndex: stepIndex } }}</p>
    <mat-progress-bar mode="determinate" [value]="stepIndex * 33.33" class="w-152"></mat-progress-bar>
  </div>
</div>
